// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1___cfbb512eccdbc808ed9","cls2":"Tooltip-cls2__ecfdec07919a30566556 Tooltip-cls1___cfbb512eccdbc808ed9"};